"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnreadPortsError = void 0;
exports.assertAllPortsRead = assertAllPortsRead;
const assertAssembled_1 = require("./assertAssembled");
/**
 * WHY THIS IS A SEPARATE FUNCTION FROM assertAssembled.
 *
 * assertAssembled runs INSIDE buildBackend, at boot, before a single use case has been constructed.
 * Nothing has been read at that moment, so folding this check into it would fail universally. The
 * two assertions answer different questions at different times:
 *
 *   assertAssembled     — "is every socket wired?"        asked at boot
 *   assertAllPortsRead  — "does every socket carry load?" asked after exercise
 *
 * WHAT THIS CATCHES THAT NOTHING ELSE DOES. A socket that is connected and never resolved. On
 * 2026-08-30 four such sockets were found on ComponentFrontendInfrastructure — graphQLAdsDomain,
 * graphQLPaymentDomain, restAuthApi, restLegalApi. connect() filled all eight so assertAssembled
 * passed; all eight paired by name so unusedLollipops stayed 0. Neither gate could see it, and the
 * traffic those four should have carried was going out through raw fetch and Apollo hooks instead.
 *
 * WHAT IT DOES NOT ESTABLISH, stated because the number will be quoted. Read-ness is a fact about a
 * moment. Asserted at the end of a test run it measures THE TEST SUITE: it proves nothing exercises
 * a port anywhere in that run, which is not the same as proving production never reaches it. A port
 * only a rare error path touches looks identical to a dead one.
 *
 * ⚠ THIS PARAGRAPH USED TO END "the static gate (ops/check-port-routing.mjs) is what generalises;
 * this is the runtime half." THAT FILE HAS NEVER EXISTED (checked 2026-09-07: no such path, and no
 * npm script referenced it). It was the only mention of it anywhere in the repository — a gate cited
 * in prose as though it ran, which is §28.32's "unmatched by anything" and §28.80's workflow whose
 * activation condition could not occur, in a third form. There is no static half. What this function
 * establishes is what is written above it, and nothing broader.
 *
 * LOLLIPOPS ARE NEVER JUDGED. A ProvidedPort reports read:false always — see IEntityPort.read for
 * why a transitive flag would double-count the socket's fact. Filtering on kind === 'required'
 * keeps that non-decision out of the assertion.
 */
class UnreadPortsError extends Error {
    ports;
    constructor(ports) {
        super(`Connected but never read: ${ports.map((p) => `${p.component}.${p.name}`).join(', ')}. ` +
            'A socket nothing resolves is a declaration, not a seam — either route the traffic through ' +
            'it, delete it, or add it to the allowlist with a comment saying which path reaches it.');
        this.ports = ports;
        this.name = 'UnreadPortsError';
    }
}
exports.UnreadPortsError = UnreadPortsError;
/**
 * @param ports          a manifest from describePorts, ideally after the system has been exercised
 * @param knownUnread    QUALIFIED port names — 'Component.Port' — allowed to be unread, each needing
 *                       a reason in the same diff. See assertAssembled for why the component is part
 *                       of the key
 */
function assertAllPortsRead(ports, knownUnread = []) {
    (0, assertAssembled_1.assertQualified)(knownUnread, 'knownUnread');
    const allowed = new Set(knownUnread);
    const unread = ports.filter((p) => p.kind === 'required' && p.connected && !p.read && !allowed.has(`${p.component}.${p.name}`));
    if (unread.length > 0)
        throw new UnreadPortsError(unread);
}
//# sourceMappingURL=assertAllPortsRead.js.map